export const exportInfractionsToExcelService = (fetch) => async (filters) => {
  try {
    const searchParams = new URLSearchParams(filters).toString();
    const response = await fetch({
      url: "/api/v1/infracciones/export/excel?" + searchParams,
      method: "get",
      data: filters,
      responseType: "blob", // Ensure the response is treated as a blob for file download
    });

    return response;
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message);
  }
};
